import React from "react";

/* global globalThis */

const BYTES_PER_KB = 1024;
const BYTES_PER_MB = BYTES_PER_KB * BYTES_PER_KB;
const MAX_REQUIREMENT_IMAGE_MB = 5;
const RANDOM_ID_RADIX = 16;
const RANDOM_ID_SLICE_START = 2;

export const MAX_REQUIREMENT_IMAGE_BYTES =
  MAX_REQUIREMENT_IMAGE_MB * BYTES_PER_MB;
export const MAX_REQUIREMENT_CERTIFICATIONS = 3;
export const ALLOWED_REQUIREMENT_IMAGE_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
];

const SELECT_BORDER_COLOR = "#909092";
const SELECT_CONTROL_HEIGHT = "30px";
const SELECT_FONT_SIZE = "16px";
const SELECT_BORDER_RADIUS = "8px";

export const createEmptyRequirement = () => ({
  idCategoria: null,
  nombreSubcategoria: null,
  titulo: null,
  fechaLimite: null,
  descripcion: null,
  ubicacion: null,
  sector: null,
  subSector: null,
  rama: null,
  certificaciones: [],
  image: null,
  volumen: null,
  experienciaMinima: null,
});

const createCertificationClientKey = () => {
  if (typeof globalThis !== "undefined" && globalThis.crypto?.randomUUID) {
    return globalThis.crypto.randomUUID();
  }
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `cert-${Date.now()}-${Math.random()
    .toString(RANDOM_ID_RADIX)
    .slice(RANDOM_ID_SLICE_START)}`;
};

export const createEmptyCertification = () => ({
  nombre: "",
  clientKey: createCertificationClientKey(),
});

export const certificationKey = (certificacion) =>
  certificacion.clientKey || certificacion._id;

export const certificationsForSubmit = (certificaciones = []) =>
  certificaciones.map((certification) => {
    const submittedCertification = { ...certification };
    delete submittedCertification.clientKey;
    return submittedCertification;
  });

export const optionId = (option) => option._id;
export const optionName = (option) => option.nombre;
export const optionLabel = (option) => <span>{option.nombre}</span>;

export const requirementImageError = (file, t) => {
  if (!ALLOWED_REQUIREMENT_IMAGE_TYPES.includes(file.type)) {
    return t("pages.buyerCompanyForm.logoFileTypeError");
  }
  if (file.size > MAX_REQUIREMENT_IMAGE_BYTES) {
    return t("pages.buyerCompanyForm.logoFileSizeError");
  }
  return "";
};

const buildRequirementSelectStyles = ({
  valueMaxWidth,
  containerWidth,
  ellipsis = false,
  alignLeft = false,
} = {}) => ({
  control: (baseStyles) => ({
    ...baseStyles,
    borderRadius: SELECT_BORDER_RADIUS,
    width: "100%",
    height: SELECT_CONTROL_HEIGHT,
    fontSize: SELECT_FONT_SIZE,
    cursor: "pointer",
    borderColor: SELECT_BORDER_COLOR,
    ...(ellipsis
      ? {
          textOverflow: "ellipsis",
          textWrap: "nowrap",
          textAlign: "left",
          maxLines: 1,
        }
      : {}),
    ...(alignLeft ? { textAlign: "left" } : {}),
  }),
  container: (baseStyles) => ({
    ...baseStyles,
    ...(containerWidth ? { width: containerWidth } : {}),
  }),
  valueContainer: (baseStyles) => ({
    ...baseStyles,
    ...(valueMaxWidth ? { maxWidth: valueMaxWidth } : {}),
  }),
  input: (baseStyles) => ({ ...baseStyles }),
  option: (baseStyles) => ({
    ...baseStyles,
    cursor: "pointer",
  }),
  indicatorSeparator: () => ({ display: "none" }),
});

export const categorySelectStyles = buildRequirementSelectStyles();
export const sectorSelectStyles = buildRequirementSelectStyles({
  ellipsis: true,
  valueMaxWidth: "200px",
});
export const subsectorSelectStyles = buildRequirementSelectStyles({
  ellipsis: true,
  valueMaxWidth: "120px",
});
export const branchSelectStyles = buildRequirementSelectStyles({
  valueMaxWidth: "120px",
});
export const certificationSelectStyles = buildRequirementSelectStyles({
  alignLeft: true,
  valueMaxWidth: "300px",
  containerWidth: "70%",
});
